import type { Translations } from './de'

const es: Translations = {
  'language.flag': '🇪🇸',
  'language.name': 'Español',
  'navigation.home': 'Inicio',
  'navigation.language': 'Idioma',
  'navigation.openMenu': 'Abrir menú',
  'navigation.closeMenu': 'Cerrar menú',
  'navigation.skipToContent': 'Saltar al contenido',
  'categories.sightseeing.name': 'Lugares de interés',
  'categories.sightseeing.heading': 'Los lugares más populares de Augsburgo',
  'categories.sightseeing.lead': 'Del Patrimonio Mundial de la UNESCO a la Fuggerei: Augsburgo ofrece más de lo que imaginas.',
  'categories.events.name': 'Eventos',
  'categories.events.heading': 'Todos los eventos de un vistazo',
  'categories.events.lead': 'Conciertos, mercados, visitas guiadas: descubre qué pasa en Augsburgo esta semana.',
  'categories.blog.name': 'Actualidad',
  'categories.blog.heading': 'Novedades de Augsburgo',
  'categories.blog.lead': 'Contexto, historia de la ciudad y temas de actualidad: para leer y compartir.',
  'categories.emptyTitle': 'Aún no hay nada',
  'categories.emptyDescription': 'Todavía no hay páginas en esta sección. Vuelve pronto.',
  'home.title': 'Bienvenido a Augsburgo',
  'home.intro': 'Escapada urbana, viaje de negocios o visita familiar: aquí encontrarás toda la información importante para tu estancia en Augsburgo.',
  'home.sightseeing.eyebrow': 'Ciudad Patrimonio Mundial de la UNESCO',
  'home.sightseeing.title': 'Descubrir lugares de interés',
  'home.sightseeing.lead': 'Del Patrimonio Mundial de la UNESCO a la Fuggerei: Augsburgo ofrece más de lo que imaginas.',
  'home.sightseeing.action': 'Descubrir ahora',
  'home.events.eyebrow': '¿Qué pasa en Augsburgo?',
  'home.events.title': 'Encontrar eventos',
  'home.events.lead': 'No te pierdas ningún concierto, mercadillo ni festival. En nuestra página de eventos siempre estarás al día.',
  'home.events.action': 'Todos los eventos',
  'home.blog.eyebrow': 'Historias de la ciudad',
  'home.blog.title': 'Novedades y curiosidades',
  'home.blog.lead': 'Aquí encontrarás todo lo importante sobre Augsburgo, para que estés bien informado durante tu visita.',
  'home.blog.action': 'Al blog',
  'home.language.eyebrow': 'Augsburgo es internacional',
  'home.language.title': 'Cambia a tu idioma',
  'home.language.lead': 'Este sitio está disponible en varios idiomas. ¿Quieres cambiar el idioma?',
  'home.highlights.eyebrow': 'Seleccionado para ti',
  'home.highlights.title': 'Nuestras recomendaciones',
  'home.highlights.lead': 'Para empezar bien, hemos reunido algunos de los mejores lugares de Augsburgo: ¡disfruta de la lectura!',
  'search.placeholder': 'Buscar...',
  'search.clear': 'Borrar búsqueda',
  'search.label': 'Buscar páginas',
  'search.results': '{{count}} resultados para «{{query}}»',
  'search.emptyTitle': 'Sin resultados',
  'search.emptyDescription': 'No hemos encontrado nada para esta búsqueda. Prueba con otro término.',
  'pagination.label': 'Páginas',
  'pagination.previous': 'Página anterior',
  'pagination.next': 'Página siguiente',
  'pagination.page': 'Página {{page}}',
  'pagination.summary': '{{start}}–{{end}} de {{total}}',
  'page.back': 'Volver',
  'page.readMore': 'Leer más',
  'page.tableOfContents': 'En esta página',
  'page.openInGoogleMaps': 'Abrir en Google Maps',
  'map.copyAddress': 'Copiar dirección',
  'map.copied': 'Copiado',
  'map.copyFailed': 'No se puede copiar',
  'map.routeInGoogleMaps': 'Ruta en Google Maps',
  'map.zoomIn': 'Acercar',
  'map.zoomOut': 'Alejar',
  'map.showAll': 'Mostrar todo',
  'attribution.toggle': 'Mostrar u ocultar las fuentes',
  'map.gestures.windows': 'Usa Ctrl + desplazamiento para hacer zoom en el mapa',
  'map.gestures.mac': 'Usa ⌘ + desplazamiento para hacer zoom en el mapa',
  'map.gestures.mobile': 'Usa dos dedos para mover el mapa',
  'map.loading': 'Cargando el mapa …',
  'map.failed': 'No se ha podido cargar el mapa.',
  'map.showPlace': 'Mostrar {{name}} en el mapa',
  'map.marker': '{{name}}, {{icon}}',
  'map.numberedMarker': '{{number}}. {{name}}, {{icon}}',
  'map.route.walkingTime': 'aprox. {{duration}} a pie',
  'map.route.stops': '{{count}} paradas',
  'map.route.leg': '{{distance}} · aprox. {{duration}}',
  'mapIcons.landmark': 'Lugar de interés',
  'mapIcons.church': 'Iglesia',
  'mapIcons.museum': 'Museo',
  'mapIcons.park': 'Parque y naturaleza',
  'mapIcons.viewpoint': 'Mirador',
  'mapIcons.cafe': 'Café',
  'mapIcons.bar': 'Bar',
  'mapIcons.restaurant': 'Restaurante',
  'mapIcons.shop': 'Compras',
  'mapIcons.event': 'Lugar de eventos',
  'mapIcons.transport': 'Transporte',
  'mapIcons.place': 'Lugar',
  'footer.imprint': 'Aviso legal',
  'footer.privacy': 'Política de privacidad',
  'footer.mediaLicense': 'Derechos de imagen',
  'legal.bindingNote': 'Esta traducción tiene carácter meramente informativo. Solo la versión alemana es jurídicamente vinculante.',
  'imprint.provider.heading': 'Información conforme al § 5 DDG',
  'imprint.contact.heading': 'Contacto',
  'imprint.contact.email': 'Correo electrónico',
  'imprint.responsible.heading': 'Responsable del contenido conforme al § 18, apdo. 2 MStV',
  'privacy.intro': 'Esta política de privacidad explica qué datos personales se tratan cuando visitas este sitio web.',
  'privacy.controller.heading': 'Responsable del tratamiento',
  'privacy.controller.text': 'El responsable del tratamiento de datos en este sitio web es:',
  'privacy.hosting.heading': 'Alojamiento',
  'privacy.hosting.text': 'Este sitio web está alojado por un proveedor de alojamiento externo con sede en Alemania. Los servidores se encuentran en Alemania.',
  'privacy.serverLogs.heading': 'Archivos de registro del servidor',
  'privacy.serverLogs.text': 'Cada vez que visitas este sitio web, el servidor guarda automáticamente la información que transmite tu navegador: dirección IP, fecha y hora de la solicitud, página solicitada, cantidad de datos transferidos, URL de referencia, así como navegador y sistema operativo. Estos datos son necesarios para el funcionamiento seguro y estable del sitio (art. 6, apdo. 1, letra f del RGPD) y se eliminan como máximo a los 7 días.',
  'privacy.analytics.heading': 'Medición de audiencia',
  'privacy.analytics.text': 'Para saber qué páginas se leen, contamos nosotros mismos las visitas a las páginas, sin servicios externos y sin cookies. Cuando abres una página, tu navegador solo comunica su dirección a nuestro servidor. Por cada dirección, idioma y día guardamos únicamente el número de visitas, separadas entre navegadores y programas automatizados (rastreadores), que distinguimos por el identificador del navegador (user agent). Tu dirección IP, el identificador de tu navegador u otros datos sobre ti no se guardan para este fin; no es posible identificar a visitantes individuales. Si tu navegador envía la señal «Global Privacy Control» o «Do Not Track», tu visita no se cuenta. Las cifras se eliminan al cabo de un año. La base jurídica es el art. 6, apdo. 1, letra f del RGPD; nuestro interés legítimo es mejorar este sitio web.',
  'privacy.errorReports.heading': 'Informes de errores',
  'privacy.errorReports.text': 'Si se produce un error técnico al cargar una página, se envía automáticamente al operador un correo electrónico con información sobre la solicitud fallida. Puede contener tu dirección IP, la dirección solicitada y datos sobre tu navegador. Los informes de errores sirven exclusivamente para corregir errores (art. 6, apdo. 1, letra f del RGPD).',
  'privacy.cookies.heading': 'Cookies',
  'privacy.cookies.text': 'Este sitio web utiliza exclusivamente cookies técnicamente necesarias, imprescindibles para tu sesión y para la protección frente a solicitudes falsificadas (CSRF). No contienen datos con fines de análisis ni de publicidad y se eliminan al cerrar tu navegador. La base jurídica es el § 25, apdo. 2, n.º 2 TDDDG en relación con el art. 6, apdo. 1, letra f del RGPD; no se requiere consentimiento. No se utilizan servicios externos de análisis ni de seguimiento; la medición de audiencia descrita arriba funciona sin cookies.',
  'privacy.rights.heading': 'Tus derechos',
  'privacy.rights.text': 'Tienes derecho a:',
  'privacy.rights.access': 'acceder a tus datos almacenados (art. 15 RGPD)',
  'privacy.rights.rectification': 'la rectificación (art. 16 RGPD)',
  'privacy.rights.erasure': 'la supresión (art. 17 RGPD)',
  'privacy.rights.restriction': 'la limitación del tratamiento (art. 18 RGPD)',
  'privacy.rights.portability': 'la portabilidad de los datos (art. 20 RGPD)',
  'privacy.rights.objection': 'oponerte al tratamiento (art. 21 RGPD)',
  'privacy.rights.contact': 'Para ejercer estos derechos, simplemente escribe un correo electrónico a:',
  'privacy.complaint.heading': 'Derecho a presentar una reclamación',
  'privacy.complaint.text': 'Tienes derecho a presentar una reclamación ante una autoridad de control de protección de datos. La autoridad competente es el Bayerisches Landesamt für Datenschutzaufsicht (BayLDA), Promenade 18, 91522 Ansbach, Alemania.',
  'privacy.updated': 'Última actualización: octubre de 2026',
  'mediaLicense.intro': 'Todas las fotos, vídeos, documentos y rutas de este sitio web pertenecen a Visit Augsburg. Puedes usarlos, compartirlos y adaptarlos bajo la licencia Creative Commons Atribución 4.0 Internacional (CC BY 4.0) – también con fines comerciales – siempre que nos cites como fuente.',
  'mediaLicense.credit.heading': 'Cómo citarnos como fuente',
  'mediaLicense.credit.text': 'Muestra este aviso de forma bien visible, junto a la imagen o el vídeo:',
  'mediaLicense.credit.link': 'Siempre que sea posible, enlaza la página de la que procede el contenido y la licencia. Si has modificado un contenido, indícalo.',
  'mediaLicense.ai.heading': 'Asistentes de IA y buscadores',
  'mediaLicense.ai.text': 'Esto también se aplica a chatbots, asistentes de IA y buscadores: quien muestre una imagen o un vídeo de este sitio web muestra con ella el aviso «{{credit}}». El autor, el aviso y la licencia figuran de forma legible por máquinas en cada archivo de imagen (IPTC/XMP) y en los datos estructurados (schema.org) de cada página.',
  'mediaLicense.license.heading': 'Licencia',
  'mediaLicense.license.text': 'Se aplica el texto de la licencia de Creative Commons:',
  'mediaLicense.license.link': 'CC BY 4.0 – Atribución 4.0 Internacional',
  'mediaLicense.scope.heading': 'Lo que no cubre la licencia',
  'mediaLicense.scope.text': 'Los textos de este sitio web no forman parte de la licencia. Los datos de los mapas proceden de OpenStreetMap y están disponibles bajo la Open Database License (© colaboradores de OpenStreetMap).',
  'mediaLicense.contact': '¿Tienes preguntas sobre el uso? Escribe un correo electrónico a:',
  'mediaLicense.updated': 'Última actualización: octubre de 2026',
  'gallery.previous': 'Imagen anterior',
  'gallery.next': 'Imagen siguiente',
  'gallery.showImage': 'Mostrar {{title}}',
  'video.play': 'Reproducir {{title}}',
  'videoGallery.summaryOne': '1 vídeo · {{minutes}} min',
  'videoGallery.summaryOther': '{{count}} vídeos · {{minutes}} min',
  'tags.unesco_heritage': 'Patrimonio UNESCO',
  'tags.landmark': 'Símbolo de la ciudad',
  'tags.church_monastery': 'Iglesia y monasterio',
  'tags.museum_culture': 'Museo y cultura',
  'tags.park_nature': 'Parque y naturaleza',
  'tags.viewpoint': 'Mirador',
  'tags.accessible': 'Accesible',
  'tags.free': 'Gratis',
  'tags.family_friendly': 'Para familias',
  'tags.concert': 'Concierto',
  'tags.market': 'Mercado',
  'tags.guided_tour': 'Visita guiada',
  'tags.festival': 'Festival',
  'tags.exhibition': 'Exposición',
  'tags.sports': 'Deporte',
  'tags.open_air': 'Al aire libre',
  'tags.city_history': 'Historia de la ciudad',
  'tags.tips_tricks': 'Consejos y trucos',
  'tags.interview': 'Entrevista',
  'tags.food_drink': 'Comida y bebida',
  'tags.seasonal': 'De temporada',
  'tags.behind_the_scenes': 'Entre bastidores',
  'tags.event_recap': 'Resumen del evento',
}

export default es
